import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useRedirectIfInvalidId = (id, redirectPath = '/dashboard') => {
  const history = useHistory();

  useEffect(() => {
    if (!id || id === 'undefined') {
      history.replace(redirectPath);
    }
  }, [id, history, redirectPath]);
};
